import { newRequest } from "std/api/newRequest";
import type { ApiBaseParams } from "std/api/types";
import type { RotaStoreFilter } from "../store";
import type { ApiRota } from "../types/ApiRota";

export type ApiRotaGetSearchParams = ApiBaseParams &
	Omit<RotaStoreFilter, "rot_transportador"> &
	Partial<{
		rot_transportador_idpk: number;
	}>;

export function apiRotaGetSearch({ idpk, params }: { idpk?: number; params?: ApiRotaGetSearchParams }): Promise<ApiRota[]> {
	return newRequest({
		url: "Rota/Search",
		type: "get",
		idpk,
		params,
	});
}
